export const MIN_INBOX_TEMPLATE_PROMPT_LEN = 30

const EMAIL_GENERATE_URL =
  "/crm/api/concierge/inbox-templates/email/generate-from-prompt/"
const EMAIL_IMPROVE_URL = "/crm/api/concierge/inbox-templates/email/improve/"
const SMS_GENERATE_URL =
  "/crm/api/concierge/inbox-templates/sms/generate-from-prompt/"
const SMS_IMPROVE_URL = "/crm/api/concierge/inbox-templates/sms/improve/"

export const INBOX_TEMPLATE_AI_REVIEW_NOTE =
  "AI will review your content for spelling, grammar, and professionalism. Verify the updated text, then save the template."

export const INBOX_TEMPLATE_AI_REVIEW_READY_NOTE =
  "AI review complete. Verify the content above, then save the template."

export async function improveEmailInboxTemplate(axios, draft) {
  const { data } = await axios.post(EMAIL_IMPROVE_URL, {
    mode: "create",
    subject: draft.subject || "",
    html_body: draft.html_body || "",
    instruction: "",
  })
  return {
    subject: data.subject || draft.subject || "",
    html_body: data.content || draft.html_body || "",
    aiReviewToken: data.ai_review_token,
  }
}

export async function improveSmsInboxTemplate(axios, draft) {
  const { data } = await axios.post(SMS_IMPROVE_URL, {
    mode: "create",
    name: draft.name || "",
    text: draft.text || "",
    instruction: "",
  })
  return {
    name: data.title || draft.name || "",
    text: data.content || draft.text || "",
    aiReviewToken: data.ai_review_token,
  }
}

export async function generateEmailInboxTemplate(axios, prompt) {
  const { data } = await axios.get(EMAIL_GENERATE_URL, { params: { prompt } })
  const templateName = data.subject || ""
  return {
    name: templateName,
    subject: templateName,
    html_body: data.content || "",
    aiReviewToken: data.ai_review_token,
  }
}

export async function generateSmsInboxTemplate(axios, prompt) {
  const { data } = await axios.get(SMS_GENERATE_URL, { params: { prompt } })
  return {
    name: data.title || "",
    text: data.content || "",
    aiReviewToken: data.ai_review_token,
  }
}
